module.exports = __webpack_public_path__ + "img/apple-app-store-btn-DE.b639d131.svg";